import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { capitalizeName, roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByVendor = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [paginationModel] = useState(paginationLimit);
  const [dataSource, setDataSource] = useState([]);

  const getAllVendorReport = async () => {
    dispatch(changeLoader(true));
    try {
      const params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };

      const response = await globalRequest(
        Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_VENDOR,
        "get",
        {},
        { params },
        true
      );

      const apiResponse = response?.data;

      if (apiResponse?.status === "SUCCESS") {
        const items = apiResponse?.data?.data?.items || [];

        const resultData = items.map((item, index) => ({
          key: item.vendorId || index,
          vendorId: item.vendorId,
          storeName: item.storeName,
          totalOrders: item.totalOrders,
          totalAmount: roundToDecimal(item.totalAmount, 2),
        }));

        setDataSource(resultData);
      } else {
        toast.error(apiResponse?.message || "Failed to fetch data");
      }
    } catch (e) {
      toast.error(e?.message || "Something went wrong");
    } finally {
      dispatch(changeLoader(false));
    }
  };

  useEffect(() => {
    getAllVendorReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => text || "-"
  },
    {
      title: "Store Name",
      dataIndex: "storeName",
      key: "storeName",
      render: (text) => capitalizeName(text || "-"),
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text) =>
        text === 0 || text
          ? roundToDecimal(text, 2)
          : "-",
    },
    {
      title: "Total Orders",
      dataIndex: "totalOrders",
      key: "totalOrders",
      render: (text, record) => (
        <Typography
          onClick={() =>
            navigate(`/get-vendor-orders/${record?.vendorId}`, {
              state: { inputData, tabIndex },
            })
          }
          className="cursor-pointer text-[#176B53]"
        >
          {text || "-"}
        </Typography>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      className="multi-tables responsive"
    />
  );
};

export default SalesByVendor;
